import request from "./httpService";
const INVOICE_ENDPOINT = '/invoice';

const save = (data) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/new`,
        data: data,
    });
}

const update = (invoice) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}`,
        data: invoice,
    });
}

const getInvoiceItems = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/items/${invoiceId}`,
    });
}

// withlimit/0/10?customerId=3
const getInvoicesForCustomerWithLimit = (from, to, filters, sortBy, customerId, signal) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy, customerId: customerId },
        signal: signal
    });
}

const deleteInvoice = (ids) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}`,
        params: { rowid: ids },
    });
}

const deletePayment = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/payment`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteInvoiceItem = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/item`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteDiscount = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/discount`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteInsuranceClaim = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/claim`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const convertQuoteToInvoice = (quoteId) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/convert-quote/${quoteId}`,
    });
};

const transferToNewInvoice = (invoiceId, transferOptions = {}) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/transfer/${invoiceId}`,
        data: transferOptions,
    });
};

const getTransferEvents = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/transfers/${invoiceId}`,
    });
};

const getTransferReasons = () => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/transferreasons`,
    });
};

const print = (invoiceId) => {
    return request({
        method: "GET",
        url: `/print/invoice/${invoiceId}`,
        responseType: 'blob',
    });
};

const printMock = () => {
    return request({
        method: "GET",
        url: `/print/test-invoice`,
        responseType: 'blob',
    });
};

// Refund methods
const createRefund = (refundData) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/refund`,
        data: refundData,
    });
};

const getRefundsByInvoiceId = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/refunds/${invoiceId}`,
    });
};

const updateRefund = (refundId, refundData) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}`,
        data: refundData,
    });
};

const updateRefundStatus = (refundId, status, authorizedBy) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}/status`,
        data: { status, authorizedBy },
    });
};

const deleteRefund = (refundId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}`,
    });
};

export const InvoiceService = {
    save,
    getInvoiceItems,
    update,
    getInvoicesForCustomerWithLimit,
    deleteInvoice,
    deletePayment,
    deleteInvoiceItem,
    deleteDiscount,
    deleteInsuranceClaim,
    convertQuoteToInvoice,
    transferToNewInvoice,
    getTransferEvents,
    print,
    printMock,
    createRefund,
    getRefundsByInvoiceId,
    updateRefund,
    updateRefundStatus,
    deleteRefund,
    getTransferReasons
}
